export const isWhiteLabeled = () =>
  process.env.REACT_APP_WHITE_LABELED?.toLowerCase() === 'true' || false

function setupCustomFeatures() {
  try {
    const jsonString = process.env.REACT_APP_FEATURES.replace(/'/g, '"')
    return JSON.parse(jsonString ?? '{}')
  } catch (e) {
    return {}
  }
}

const customFeatures = setupCustomFeatures()

const getSettingsFromLocalStorage = (feature, defaultValue = false) =>
  localStorage?.getItem(`f_feature_${feature}`) || defaultValue

const DEFAULT_FEATURES = {
  score: true,
  credit: true,
  upgrade: true,
  billing: true,
  invite: true,
  verifyMobile: true,
  subDomain: true,
  customSubdomain: true,
  customDomain: true,
  boardCustomDomain: true,
  requestGateway: true,
  apiSettings: true,
  singleLogic: true,
  emailVerification: true,
  importForm: true,
  subscriptionDetails: true,
  integrations: true,
  workspaceMembers: true,
  customPlaceholderImage: false,
  newDashboard: true,
  apps: true,
  tutorials: false,
  ...customFeatures,
}

const WHITE_LABELED_FEATURES = {
  customLogo: true,
  score: false,
  credit: false,
  upgrade: false,
  billing: false,
  invite: true,
  verifyMobile: false,
  subDomain: false,
  customSubdomain: false,
  customDomain: false,
  requestGateway: false,
  apiSettings: false,
  singleLogic: true,
  emailVerification: false,
  importForm: true,
  subscriptionDetails: true,
  integrations: false,
  workspaceMembers: true,
  customPlaceholderImage: false,
  newDashboard: false,
  apps: true,
  tutorials: true,
  ...customFeatures,
}

export const APP_FEATURES = isWhiteLabeled()
  ? WHITE_LABELED_FEATURES
  : DEFAULT_FEATURES

export const getFeatureToggleValueOutOfContext = (key) => APP_FEATURES[key]
